module.exports = __webpack_public_path__ + "static/media/exchange.4643ffe0.png";